export const THEME_CLASS = {
    light: '',
    dark: 'dark-mode',
}